import LogoutIcon from '@mui/icons-material/Logout';
import { IconButton, Tooltip } from '@mui/material';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useLogoutMutation } from 'api/mutations/useLogoutMutation';
import { NewConfirmDialog } from 'components/Dialogs';
import { useAuth, useModal, useSubscription, useWindowSize } from 'hooks';
import { Links } from 'settings';

import { NavLink } from '../NavLink';
import { MENU_ITEMS } from './config';
import { LogoW, ListItems, NavBarW, DividerW, ListItemsMainW } from './styled';

export function NavigationBar(): ReactElement {
  const { user, removeCurrentUser } = useAuth();
  const { isExpired } = useSubscription();
  const { isMobile } = useWindowSize();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { logoutMutation, isLoading } = useLogoutMutation();
  const {
    isOpen: isConfirmOpen,
    handleOpenModal: openConfirm,
    handleCloseModal: closeConfirm,
  } = useModal();

  const { ACTIONS, WE, ME, RESOURCES } = MENU_ITEMS(
    user?.id || '',
    user?.avatar?.small || '',
    isMobile,
  );

  async function handleLogout() {
    await logoutMutation();
    removeCurrentUser();
    closeConfirm();
    navigate(Links.auth.signIn);
    if (Notification.permission === 'granted') {
      window.location.reload();
    }
  }

  return (
    <NavBarW disabled={isExpired}>
      <ListItemsMainW>
        <ListItems>
          <NavLink
            to={ACTIONS.path}
            icon={ACTIONS.icon}
            label={ACTIONS.label}
            disabled={isExpired}
          />
          <NavLink
            to={RESOURCES.path}
            icon={RESOURCES.icon}
            label={RESOURCES.label}
            disabled={isExpired}
          />
          <NavLink to={WE.path} icon={WE.icon} label={WE.label} disabled={isExpired} />
          <NavLink to={ME.path} icon={ME.icon} label={ME.label} disabled={isExpired} />
        </ListItems>
        <DividerW />
      </ListItemsMainW>

      <LogoW>
        <Tooltip title={t('profile.logout.text')} placement="right">
          <IconButton onClick={openConfirm} size="small">
            <LogoutIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </LogoW>

      <NewConfirmDialog
        open={isConfirmOpen}
        title={t('profile.logout.confirmText')}
        subTitle={t('profile.logout.subText')}
        onClose={closeConfirm}
        onConfirm={handleLogout}
        isLoading={isLoading}
        submitLabel={t('profile.logout.confirmYes')}
        cancelLabel={t('profile.logout.confirmNo')}
      />
    </NavBarW>
  );
}
